/*
 * @Desc: banner管理 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-05-29 17:26:15
 */
import request from "@/utils/request";
const index = {
  // 广告位管理
  // 列表
  list (query) {
    return request({
      url: "/adpos/list",
      method: "get",
      params: query
    });
  },
  // 新增
  create (data) {
    return request({
      url: "/adpos/create",
      method: "post",
      data
    });
  },
  // 编辑
  edit (data) {
    return request({
      url: "/adpos/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail (query) {
    return request({
      url: "/adpos/detail",
      method: "post",
      params: query
    });
  },
  // 删除
  remove (data) {
    return request({
      url: "/adpos/remove",
      method: "post",
      data
    });
  },
  // 下拉选
  select (query) {
    return request({
      url: "/adpos/select",
      method: "get",
      params: query
    });
  },
  // 官网banner 管理
  // 列表
  bannerList (query) {
    return request({
      url: "/ad/list",
      method: "get",
      params: query
    });
  },
  // 新增
  bannerCreate (data) {
    return request({
      url: "/ad/create",
      method: "post",
      data
    });
  },
  // 编辑
  bannerEdit (data) {
    return request({
      url: "/ad/edit",
      method: "post",
      data
    });
  },
  // 详情
  bannerDetail (query) {
    return request({
      url: "/ad/detail",
      method: "get",
      params: query
    });
  },
  // 删除
  bannerRemove (data) {
    return request({
      url: "/ad/remove",
      method: "post",
      data
    });
  },
  // 排序
  bannerSort (data) {
    return request({
      url: "/ad/sort",
      method: "post",
      data
    });
  },
  // 更改状态
  bannerStatus (data) {
    return request({
      url: "/ad/status",
      method: "post",
      data
    });
  },
};
export default index;